import { defineComponent as _defineComponent } from 'vue'
import { ITicketPurchased } from '@/features/tickets/types'
import { useTicketsForEventQuery } from '@/features/tickets/api/queries'
import { computed, ref } from 'vue'
import BKButton from '@/components/AppShared/BKButton.vue'
import { centsToDollars } from '@/services/currency'
import { ModalWrapper } from '@/shared/ui/modals'
import ChangeTicketsInterface from '@/features/tickets/ui/ChangeTicketsInterface.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeTierInterface',
  props: {
    currentTicket: null,
    eventId: null,
    isAdmin: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  currentTicket: ITicketPurchased
  eventId: number
  isAdmin?: boolean
};



const { data: tiers, isLoading: isLoadingTickets, isError: isTicketsError } = useTicketsForEventQuery(props.eventId)

const selectedTierId = ref<number | null>(props.currentTicket.tierId)
const isTierChanged = computed(() => {
  return selectedTierId.value !== null && selectedTierId.value !== props.currentTicket.tierId
})
const getPriceDifferenceToCurrentTier = (tierId: number) => {
  if (!tiers.value) return 0
  const selectedTier = tiers.value.tiers.find((tier) => tier.id === tierId)
  if (!selectedTier) return 0
  return (selectedTier.priceWithDiscount || selectedTier.price) - props.currentTicket.cost
}


const isShowPurchaseModal = ref(false)

const handleChangeTier = () => {
  isShowPurchaseModal.value = true
}

const handleTierChanged = () => {
  isShowPurchaseModal.value = false
  emit('close')
}

return { __sfc: true,props, tiers, isLoadingTickets, isTicketsError, selectedTierId, isTierChanged, getPriceDifferenceToCurrentTier, emit, isShowPurchaseModal, handleChangeTier, handleTierChanged, BKButton, centsToDollars, ModalWrapper, ChangeTicketsInterface }
}

})